<template>
  <div class="slider-container">
    <swiper ref="mySwiper" :options="swiperOptions">
        <!-- <swiper-slide :data-swiper-autoplay="duration + '000'">
            <div class="slide-header" :style="{backgroundImage: `url(${require('../../assets/gcla/slider-1.png')})`}">
                <div class="widget">
                    <div class="top-line" :style="{backgroundColor: `${'#0719A3'}`}"></div>
                    <div class="bg-title mb-2" v-html="'Discover who we are'"></div>
                    <div class="text mb-4 white-color" v-html="'Global Council for Law, Arbitration and Intellectual Property<br /> (GCLA) is One of the world’s premier professional studies and<br /> research institutions, (GCLA) has driven new ways of thinking<br /> since our 1998 founding.'"></div>
                    <router-link to="/" class="explore-btn" v-html="'Explore'"></router-link>
                </div>
            </div>
        </swiper-slide> -->
        <swiper-slide v-for="(row, index) in rows" :key="index" :data-swiper-autoplay="row.duration + '000'">
            <div class="slide-header" :style="{backgroundImage: `url(${row.file}) !important`}">
                <div class="container-fluid">
                  <div class="widget">
                    <div class="top-line" :style="'backgroundColor:'+row.bgColor+' !important'"></div>
                    <div class="bg-title mb-2" v-html="row.title"></div>
                    <div class="text mb-4 white-color" v-html="row.body"></div>
                    <router-link v-if="row.redirect" :to="row.redirect" class="explore-btn" v-html="row.button"></router-link>
                  </div>
                </div>
            </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
    <div class="container-fluid">
      <div class="swiper-arrows d-flex">
        <button class="arr-btn" @click="prev">
          <span class="icon-arrow-left"></span>
        </button>
        <button class="arr-btn" @click="next">
          <span class="icon-arrow-right"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.slider-container {
  position: relative;
}
.swiper-container {
  height: calc(100vh - 328.62px);
  min-height: 450px;
  position: relative;
}
.slide-header {
  height: 100%;
  background-size: cover;
}
.widget {
  position: absolute;
  left: 60px;
  bottom: 80px;
  width: auto;
  display: inline-block;
}
.bg-title {
  color: #fff;
  font-size: 40px;
}
.top-line {
  height: 5px;
  width: 80px;
  margin-bottom: 13px;
}
.explore-btn {
  color: #fff;
  font-size: 18px;
  border: 1px solid #fff;
  padding: 5px 18px;
  line-height: 1;
  display: inline-block;
}
.explore-btn:hover {
  background: #fff;
  color: #000;
}
.explore-btn:active {
  opacity: 0.6;
}
.swiper-arrows {
  position: absolute;
  bottom: 50px;
  right: 50px;
  line-height: 1;
  z-index: 10;
}
.arr-btn {
  color: #fff;
  font-size: 27px;
  margin-left: 16px;
}
.arr-btn:hover {
  color: #ddd;
}
.arr-btn:active {
  opacity: 0.6;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .swiper-container {
    height: calc(100vh - 68px);
    /* min-height: auto; */
  }
  .slide-header {
    padding: 0;
    background-position: center;
  }
  .swiper-arrows {
    bottom: 20px;
    right: 50%;
    transform: translateX(50%);
  }
  .arr-btn {
    margin: 0 10px
  }
  .widget {
    left: 0;
    padding: 20px;
  }
  .bg-title {
    font-size: 40px;
    margin-bottom: 24px;
  }
  .explore-btn {
    writing-mode: inherit;
    text-orientation: initial;
    position: static;
    transform: none;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .bg-title {
    font-size: 56px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .swiper-container {
    height: calc(100vh - 91.45px);
    /* min-height: auto; */
  }
  .slide-header {
    padding: 100px 20px 95px;
  }
  /* .widget {
    position: static;
  } */
  /* .bg-title {
    font-size: 40px;
    margin-bottom: 24px;
  } */
  .explore-btn {
    writing-mode: inherit;
    text-orientation: initial;
    /* position: static; */
    /* transform: none; */
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Slider",
//   props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  
  data() {
    return {
      pgLoading: true,
      duration: 4,
      rows: [],
      swiperOptions: {
        loop: false,
        speed: 800,
        autoplay: {
            
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 10,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
      }
    };
  },
  created() {
    this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },
    prev() {
        this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
        this.$refs.mySwiper.$swiper.slideNext();
    },
  },
};
</script>
